import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

export const DirectContactFaxDialogContent: FC<{
  onClick: () => void
}> = ({ onClick }) => {
  return (
    <>
      <div className="mb-5 flex flex-col gap-5 text-center tablet:w-96 tablet:gap-6">
        <p className="text-xl font-medium">
          <FormattedMessage id="contact.directContact.faxDialog.faxNumber.title" />
        </p>
        <p>
          <FormattedMessage id="contact.directContact.faxDialog.faxNumber.number" />
        </p>
      </div>
      <Button
        className="mt-4 w-full"
        color="primary"
        onClick={onClick}
        variant="outlined"
      >
        <FormattedMessage id="general.button.cancel" />
      </Button>
    </>
  )
}
